import type { ICatalog } from '@platform/core/types';
import { onboardingGroups } from '@platform/navigation';
import type { IOrderedSummary } from './IOrderedSummary';

/**
 * Основні модулі, які новий простір прототипу має завжди (makeWs: Справи, Завдання — «завжди включено»), у порядку простору: установлені
 * основні модулі каталогу, яких екран «Створити робочий простір» не пропонує на вибір (база знань і CRM там необов'язкові). Чиста функція.
 */
export function alwaysIncluded(catalog: ICatalog | undefined): string[] {
  const offered = new Set(onboardingGroups().flatMap((g) => g.modules.map((m) => m.key.split('/')[0] ?? m.key)));
  const order = (m: IOrderedSummary) => m.order ?? Number.MAX_SAFE_INTEGER;
  return (catalog?.modules ?? []).filter((m) => m.installed && m.core && !offered.has(m.key)).sort((a, b) => order(a) - order(b)).map((m) => m.key);
}
